import { useState } from 'react';
import { useStoreCouponToWallet } from '../../../api/requests/coupont.request';
import type { CouponContentResponse } from '../../../types/front.graphql';

export const useAddCouponToWallet = () => {
    const [addingCouponId, setAddingCouponId] = useState<string | null>(null);
    const { addCouponToWallet, loading } = useStoreCouponToWallet();

    const handleAddCoupon = async (item: CouponContentResponse) => {
        const couponId = item?.salesrule?.coupon_id?.toString();
        const couponCode = item?.salesrule?.code;

        if (!couponId || !couponCode) return;

        setAddingCouponId(couponId);

        try {
            await addCouponToWallet({ couponCode });
        } catch {
            // Error handling can be added here if needed
        } finally {
            setAddingCouponId(null);
        }
    };

    const isAdding = (couponId: string) => loading && addingCouponId === couponId;

    const getActionLabel = (item: CouponContentResponse, type?: string) => {
        if (item.is_in_wallet && type !== 'eWalletVoucher') {
            return 'Đã lấy';
        } else if (type === 'eWalletVoucher') {
            return 'Xem chi tiết';
        } else {
            return 'Lấy mã';
        }
    };

    return { handleAddCoupon, isAdding, getActionLabel };
};
